// import React, { useRef, useState, useEffect } from 'react';
// import DashboardMap2 from 'map/DashboardMap2';
// import ApiService from "services/ApiService";
// export default function GisView2({}) {

//     const mapRef = React.useRef();

//     const [layerIndex, setLayerIndex] = useState(0);
//     const [layerList, setLayerList] = useState(GisLayerList);
//     const [selLayerList, setSelLayerList] = useState(layerList[0]);

//     React.useEffect(() => {
//         const map = mapRef.current;
//         map.setLayerVisible(layerIndex, selLayerList);
//     }, [selLayerList]);

//     const handleClick = (e, i) => {
//         setLayerIndex(i);
//         setSelLayerList(layerList[i]);
//     }

//     return (
//         <div style={{ width: "100%", height: "100%", background:"var(--bg-gradient)", }}>
//             <div style={{ position:'relative', height: '100%', width: '100%', padding:'60px 0', borderRadius:'40px', display: 'grid' }}>
//                 <DashboardMap2
//                     ref={mapRef}
//                 />
//             </div>            
//             <div className='mapBtn'>
//                 {['mapFclBtn', 'mapTrfBtn', 'mapSgnlBtn', 'mapSelfBtn', 'mapBisBtn'].map((item, index) => (
//                     <div
//                         key={index}
//                         className={`${item} ${layerIndex === index ? "on" : ""}`}
//                         onClick={(e) => handleClick(e, index)}>
//                     </div>
//                 ))}
//             </div>
//             <GisLayerCheck layerList={selLayerList} setLayerList={setSelLayerList} layerIndex={layerIndex}></GisLayerCheck>
//         </div>
//     )
// }

import React, { useRef, useState, useEffect } from 'react';
import DashboardMap2 from 'map/DashboardMap2';
import { useDashboard } from '../components/DashboardContext';
import GisLayerCheck from '../components/GisLayerCheck.js';
import { GisLayerList } from 'map/layers/GisLayerInfo';

export default function GisView2() {
    const mapRef = useRef();
    const [layerIndex, setLayerIndex] = useState(1);
    const { activeView, mapMessages } = useDashboard();
    const [layerList, setLayerList] = useState(GisLayerList);
    const [selLayerList, setSelLayerList] = useState(layerList[1]);

    React.useEffect(() => {
        const map = mapRef.current;
        map.setLayerVisible(layerIndex, selLayerList);
    }, [selLayerList]);

    const handleClick = (e, i) => {
        setLayerIndex(i);
        setSelLayerList(layerList[i]);
    }
    useEffect(() => {
        const savedView = localStorage.getItem('dashboard:activeView');
        if (savedView) updateMapLayers(savedView);
    }, []);

    useEffect(() => {
        if (activeView) updateMapLayers(activeView);
    }, [activeView]);

    useEffect(() => {
        if (mapMessages.length > 0) {
            const latestMsg = mapMessages[mapMessages.length - 1];
            if (latestMsg.startsWith('VIEW_CHANGED:')) {
                const viewType = latestMsg.split(':')[1];
                updateMapLayers(viewType);
            }
        }
    }, [mapMessages]);

    // 레이어 업데이트 함수
    const updateMapLayers = (viewType) => {
        const viewToLayerMap = {
            'integratedControl': 0,
            'roadTraffic': 1,
            'trafficSafety': 2,
            'signalOperation': 3,
            'busOperation': 4,
            'futureTransportation': 5
        };

        const newIndex = viewToLayerMap[viewType];
        if (newIndex !== undefined && newIndex !== layerIndex) {
            // setLayerIndex(newIndex);
            // if (mapRef.current) {
            //     mapRef.current.setLayerVisible(newIndex, true);
            // }
            console.log(`지도 레이어 변경됨: ${viewType} (${newIndex}번)`);
        }
    };

       return (
        <div style={{ width: "100%", height: "100%", background:"var(--bg-gradient)", }}>
            <div style={{ position:'relative', height: '100%', width: '100%', padding:'60px 0', borderRadius:'40px', display: 'grid' }}>
                <DashboardMap2
                    ref={mapRef}
                />
            </div>            
            <div className='mapBtn'>
                {['mapFclBtn', 'mapTrfBtn', 'mapSgnlBtn', 'mapSelfBtn', 'mapBisBtn'].map((item, index) => (
                    <div
                        key={index}
                        className={`${item} ${layerIndex === index ? "on" : ""}`}
                        onClick={(e) => handleClick(e, index)}>
                    </div>
                ))}
            </div>
            <GisLayerCheck layerList={selLayerList} setLayerList={setSelLayerList} layerIndex={layerIndex}></GisLayerCheck>
        </div>
    )
}